import { computed, ref } from "vue";
import { useStoreCompat } from "./useStoreCompat";
import { useUserAccess } from "./useUserAccess";

export function useActuacionFilters(getActuacionesUserByStationId) {
  const store = useStoreCompat();
  const { esTipoUsuario } = useUserAccess();

  const user = computed(() => store.state.user);

  const filterDropdown = ref({
    "exp_pre_TipoActuacion.TipoActuacionID": {
      optionValue: "value",
      optionLabel: "name",
      options: [],
    },
    "exp_pre_EstadoActuacion.TipoEstadoActuacionID": {
      optionValue: "value",
      optionLabel: "name",
      options: [
        { name: "En Curso", value: "En Curso" },
        { name: "Vencida", value: "Vencida" },
        { name: "Finalizada", value: "Finalizada" },
      ],
    },
    DependenciaID: {
      optionValue: "id",
      optionLabel: "dependencia",
      options: [],
      changeDropdown: async (value, filters) => {
        let dependenciaID = filters ? value.id : value; //si es llamada desde el create value ya es el id, caso contrario selecciona el id dentro de value
        if (esTipoUsuario(["Super User"])) {
          //Si es un Super User no queremos que filtre por la dependencia, queremos que traiga todos los User
          dependenciaID = null;
        }
        filterDropdown.value["exp_pre_ActuacionUsuarioDependencia.UsuarioID"].options =
          getActuacionesUserByStationId(dependenciaID);
      },
      refreshDropdown: async () => {
        await store.dispatch("siis/setDependencias", true);
        filterDropdown.value["DependenciaID"].options = store.state.siis.dependencia;
      },
      loadDropdown: async () => {
        await store.dispatch("siis/setDependencias");
        filterDropdown.value["DependenciaID"].options = store.state.siis.dependencia;
      },
    },
    JuzgadoID: {
      optionValue: "JuzgadoID",
      optionLabel: "Nombre",
      options: [],
      refreshDropdown: async () => {
        await store.dispatch("siis/setJuzgados", true);
        filterDropdown.value["JuzgadoID"].options = store.state.siis.juzgados;
      },
      loadDropdown: async () => {
        await store.dispatch("siis/setJuzgados");
        filterDropdown.value["JuzgadoID"].options = store.state.siis.juzgados;
      },
    },
    propietario: {
      optionValue: "value",
      optionLabel: "name",
      options: [
        { value: 0, name: "Mis registros" },
        { value: 1, name: "Dependencia Registros" },
      ],
    },
    RolesOficiales: {
      optionValue: "value",
      optionLabel: "name",
      options: [
        { value: "jefe de sumario", name: "Jefe de sumario" },
        { value: "jefe de dependencia", name: "Jefe de dependencia" },
        { value: "oficial sumariante", name: "Oficial sumariante" },
      ],
    },
    ModusOperandi: {
      optionValue: "Nombre",
      optionLabel: "Nombre",
      options: [],
      refreshDropdown: async () => {
        await store.dispatch("siis/setModusoperandi", true);
        filterDropdown.value["ModusOperandi"].options = store.state.siis.modusoperandi;
      },
      loadDropdown: async () => {
        await store.dispatch("siis/setModusoperandi");
        filterDropdown.value["ModusOperandi"].options = store.state.siis.modusoperandi;
      },
    },
    Articulo: {
      optionValue: "ArticulosID",
      optionLabel: "Numeroarticulo",
      options: [],
      refreshDropdown: async () => {
        await store.dispatch("siis/setArticulos", true);
        filterDropdown.value["Articulo"].options = store.state.siis.articulos;
      },
      loadDropdown: async () => {
        await store.dispatch("siis/setArticulos");
        filterDropdown.value["Articulo"].options = store.state.siis.articulos;
      },
    },
    Departamental: {
      optionValue: "DepartamentalID",
      optionLabel: "Nombre",
      options: [],
      refreshDropdown: async () => {
        await store.dispatch("siis/setDepartamentales", true);
        filterDropdown.value["Departamental"].options = store.state.siis.departamentales;
      },
      loadDropdown: async () => {
        await store.dispatch("siis/setDepartamentales");
        filterDropdown.value["Departamental"].options = store.state.siis.departamentales;
      },
    },
    Sitio: {
      optionValue: "TipoSitioID",
      optionLabel: "Nombre",
      options: [],
      refreshDropdown: async () => {
        await store.dispatch("siis/setSitio", true);
        filterDropdown.value["Sitio"].options = store.state.siis.sitio;
      },
      loadDropdown: async () => {
        await store.dispatch("siis/setSitio");
        filterDropdown.value["Sitio"].options = store.state.siis.sitio;
      },
    },
    actuacionesOf: { id: 1, option: "Dependencia Registros" },
    "exp_pre_ActuacionUsuarioDependencia.UsuarioID": {
      optionValue: "UsuarioID",
      optionLabel: "apellido_nombre",
      options: [],
    },
  });

  const filtersFields = ref([
    { name: "Actuaciones", field: "exp_pre_TipoActuacion.TipoActuacionID", hideOperators: true },
    { name: "Numero de Actuacion", field: "exp_pre_Actuacion.Numero" },
    { name: "Fecha de Creacion", field: "createdAt", type: "date" },
    {
      name: "Número de identificación Denunciante",
      field: "exp_pre_PersonaFisica.NumeroIdentificacion",
      addFilter: {
        "exp_pre_ActuacionPersonaFisica.TipoRolPersonaFisicaID": [
          { operator: "CONTAINS", value: "Denunciante" },
        ],
      },
    },
    {
      name: "Número de identificación Damnificado",
      field: "exp_pre_PersonaFisica.NumeroIdentificacion",
      addFilter: {
        "exp_pre_ActuacionPersonaFisica.TipoRolPersonaFisicaID": [
          { operator: "CONTAINS", value: "Damnificado" },
        ],
      },
    },
    {
      name: "Afectado Telefono",
      field: "exp_pre_PersonaFisica.Telefono",
      addFilter: {
        "exp_pre_ActuacionPersonaFisica.Telefono": [],
      },
    },
    {
      name: "Número de identificación Acusado",
      field: "exp_pre_PersonaFisica.NumeroIdentificacion",
      addFilter: {
        "exp_pre_ActuacionPersonaFisica.TipoRolPersonaFisicaID": [
          { operator: "=", value: "Acusado" },
        ],
      },
    },
    {
      name: "Apodo",
      field: "exp_pre_PersonaFisica.Apodo",
      addFilter: {
        "exp_pre_ActuacionPersonaFisica.TipoRolPersonaFisicaID": [
          { operator: "=", value: "Acusado" },
        ],
      },
    },
    {
      name: "Estado",
      field: "exp_pre_EstadoActuacion.TipoEstadoActuacionID",
      addFilter: {
        ConUsuarioAsignado: [{ operator: "=", value: "true" }],
      },
      hideOperators: true,
    },
    {
      name: "Propietario",
      field: "propietario",
      hideOperators: true,
    },
    {
      name: "Causa/Caratula",
      field: "exp_pre_Tipocausacaratula.TipocausacaratulaID",
    },
    {
      name: "Modus Operandi",
      field: "ModusOperandi",
      hideOperators: true,
    },
    {
      name: "Articulo",
      field: "Articulo",
      hideOperators: true,
    },
    {
      name: "Departamental",
      field: "Departamental",
      hideOperators: true,
    },
    {
      name: "Usuario por Rol",
      field: "RolesOficiales",
      hideOperators: true,
    },
    {
      name: "Sitio",
      field: "Sitio",
      hideOperators: true,
    },
  ]);

  const enableFilterMultiple = ref(true);

  const orderedDropdown = () => {
    return Object.keys(filterDropdown.value)
      .sort()
      .reduce((acc, key) => {
        acc[key] = filterDropdown.value[key];
        return acc;
      }, {});
  };

  const initFilters = async () => {
    if (
      !esTipoUsuario([
        "Deposito Judicial",
        "Oficial Sumariante",
        "Jefe de Dependencia",
        "Jefe de Sumario",
      ])
    ) {
      filtersFields.value.push(
        { name: "Dependencia", field: "DependenciaID", limit: 1, hideOperators: true },
        { name: "Juzgados", field: "JuzgadoID", limit: 1, hideOperators: true },
        { name: "Dependencias", field: "DependenciaID", type: "multiple", multiple: true }
      );
      await filterDropdown.value["DependenciaID"]?.loadDropdown();
      await filterDropdown.value["JuzgadoID"]?.loadDropdown();
    }

    if (esTipoUsuario(["Juez", "Ayudante de Juez"])) {
      filterDropdown.value["exp_pre_TipoActuacion.TipoActuacionID"].options = filterDropdown.value[
        "exp_pre_TipoActuacion.TipoActuacionID"
      ].options.filter((option) => !option.name.includes("UFI"));
      filtersFields.value = filtersFields.value.filter(
        (obj) => obj.name !== "Juzgado" && obj.name !== "Propietario"
      );
    }

    if (
      esTipoUsuario([
        "Super User",
        "User Tester",
        "Super Usuario de E3",
        "Jefe de Sumario",
        "Jefe de Dependencia",
        "Dpto. Planeamiento",
      ])
    ) {
      filtersFields.value.push({
        name: "Usuario",
        field: "exp_pre_ActuacionUsuarioDependencia.UsuarioID",
        hideOperators: true,
      });
      await store.dispatch("siis/setUserList");
      await filterDropdown.value["DependenciaID"].changeDropdown(
        user.value?.userdata.dependenciaID,
        null
      );
    }

    await filterDropdown.value["ModusOperandi"]?.loadDropdown();
    await filterDropdown.value["Articulo"]?.loadDropdown();
    await filterDropdown.value["Departamental"]?.loadDropdown();
    await filterDropdown.value["Sitio"]?.loadDropdown();

    filtersFields.value.sort((a, b) => a.name.localeCompare(b.name));
  };

  const preloadDropdownOptionsFromQuery = async (queryString) => {
    try {
      const parsed = JSON.parse(queryString);
      const dropdownKeys = Object.keys(parsed);

      for (const key of dropdownKeys) {
        const dropdown = filterDropdown.value[key];
        if (dropdown?.loadDropdown) {
          await dropdown.loadDropdown();
        }
      }
    } catch (e) {
      console.error("Error cargando dropdowns desde query:", e);
    }
  };

  return {
    filterDropdown,
    filtersFields,
    enableFilterMultiple,
    orderedDropdown,
    initFilters,
    preloadDropdownOptionsFromQuery,
  };
}
